"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var core_1 = require("@angular/core");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var overdue_warning_service_1 = require("../../../shared/services/api/overdue-warning.service");
var pending_action_settings_service_1 = require("../../../shared/services/api/pending-action-settings.service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var zip_1 = require("rxjs/observable/zip");
var pending_item_type_1 = require("../model/pending-item-type");
var portfolio_definitions_service_1 = require("../../../shared/services/api/portfolio-definitions.service");
var of_1 = require("rxjs/observable/of");
var static_method_1 = require("../../../shared/utils/static-method");
var PendingActionHelperService = /** @class */ (function () {
    function PendingActionHelperService(entitySearchService, processService, overdueWarningService, pendingActionSettingsService, kbService, portfolioDefinitionsService) {
        this.entitySearchService = entitySearchService;
        this.processService = processService;
        this.overdueWarningService = overdueWarningService;
        this.pendingActionSettingsService = pendingActionSettingsService;
        this.kbService = kbService;
        this.portfolioDefinitionsService = portfolioDefinitionsService;
        this._categorySettings = [];
    }
    PendingActionHelperService_1 = PendingActionHelperService;
    PendingActionHelperService.constructSearchableDataLoadingFilter = function (pendingItem) {
        if (pendingItem.finalStateIds && pendingItem.finalStateIds.length) {
            var wfStatesFilter = {
                '$not': {
                    'WFStateID': {
                        '$intersection': pendingItem.finalStateIds
                    }
                }
            };
            return static_method_1.uniteFilters(wfStatesFilter, pendingItem.defaultFilterJson);
        }
        else {
            return pendingItem.defaultFilterJson;
        }
    };
    PendingActionHelperService.uniteFilters = function (filter1, filter2) {
        return filter1 && filter2 ?
            { '$and': [filter1, filter2] } : (filter1 || filter2);
    };
    PendingActionHelperService.constructPendingFilteringObjectByType = function (pendingItem, pendingItemType) {
        var _a;
        if (pendingItemType === pending_item_type_1.PendingItemType.DRAFT) {
            var draftItemsFilter = pendingItem.initialStateId ? { 'WFStateID': pendingItem.initialStateId } : null;
            return PendingActionHelperService_1.uniteFilters(pendingItem.defaultFilterJson, draftItemsFilter);
        }
        if (pendingItemType === pending_item_type_1.PendingItemType.PENDING_REACTION) {
            var pendingReactionFilter = pendingItem.initialStateId ? { '$not': { 'WFStateID': pendingItem.initialStateId } } : null;
            return PendingActionHelperService_1.uniteFilters(PendingActionHelperService_1.constructSearchableDataLoadingFilter(pendingItem), pendingReactionFilter);
        }
        if (pendingItemType === pending_item_type_1.PendingItemType.OVERDUE) {
            var overdueItemsFilter = (_a = {}, _a[pendingItem.instanceField] = { '$intersection': pendingItem.allOverdueItemIds }, _a);
            return PendingActionHelperService_1.uniteFilters(PendingActionHelperService_1.constructSearchableDataLoadingFilter(pendingItem), overdueItemsFilter);
        }
        return PendingActionHelperService_1.constructSearchableDataLoadingFilter(pendingItem);
    };
    PendingActionHelperService.prototype.loadPendingActionItems = function () {
        var _this = this;
        var loadProcesses$ = Observable_1.Observable.from(this.processService.getProcesses());
        var loadPendingActionSettings$ = this.pendingActionSettingsService.loadPendingActionSettings();
        return zip_1.zip(loadProcesses$, loadPendingActionSettings$)
            .pipe(operators_1.switchMap(function (_a) {
            var processDtos = _a[0], categorySettings = _a[1];
            _this._categorySettings = categorySettings || [];
            return zip_1.zip(_this.constructProcessStructures(processDtos), _this.constructInitialPendingActionItems());
        }), operators_1.switchMap(function (_a) {
            var structures = _a[0], initialPendingActionItems = _a[1];
            if (structures && initialPendingActionItems && structures.length && initialPendingActionItems.length) {
                initialPendingActionItems.forEach(function (pendingItem) {
                    _this.setPendingActionItemInitialFinalState(pendingItem, structures);
                });
            }
            return _this.getPendingItemsWithLoadedProperties(initialPendingActionItems);
        }));
    };
    PendingActionHelperService.prototype.constructProcessStructures = function (processDtos) {
        var _this = this;
        var processStructures$ = [];
        var categorySystemNames = this._categorySettings.map(function (setting) { return setting.itemCategoryName; });
        processDtos.forEach(function (process) {
            if (categorySystemNames.indexOf(process.getCategorySystemName()) !== -1) {
                processStructures$.push(Observable_1.Observable.from(_this.processService.getStructure(process.getId())));
            }
        });
        return processStructures$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, processStructures$) : Observable_1.Observable.of([]);
    };
    PendingActionHelperService.prototype.constructInitialPendingActionItems = function () {
        var _this = this;
        var pendingActionItems$ = [];
        this._categorySettings.forEach(function (setting) {
            if (setting.itemCategoryName) {
                var loadCategoryInstanceMetaField$ = _this.kbService.getInstanceMetaField(setting.itemCategoryName);
                var loadPortfolioDefinition$ = setting.portfolioId ?
                    _this.portfolioDefinitionsService.loadPortfolioDefinitionById(setting.portfolioId, setting.itemCategoryName)
                    : of_1.of(null);
                var constructPendingActionItems$ = zip_1.zip(loadCategoryInstanceMetaField$, loadPortfolioDefinition$)
                    .pipe(operators_1.map(function (_a) {
                    var instanceMetaField = _a[0], portfolioDefinition = _a[1];
                    var pendingItem = __assign({}, setting);
                    pendingItem.externalFilters = portfolioDefinition && portfolioDefinition.externalFilters;
                    pendingItem.defaultFilterJson = static_method_1.uniteFilters(pendingItem.defaultFilterJson, portfolioDefinition && portfolioDefinition.defaultFilterJson);
                    pendingItem.instanceField = instanceMetaField.getSystemName();
                    return pendingItem;
                }));
                pendingActionItems$.push(constructPendingActionItems$);
            }
        });
        return pendingActionItems$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, pendingActionItems$) : Observable_1.Observable.of([]);
    };
    PendingActionHelperService.prototype.getPendingItemsWithLoadedProperties = function (pendingActionItems) {
        var _this = this;
        var loadItemsProperties$ = [];
        if (pendingActionItems && pendingActionItems.length) {
            pendingActionItems.slice().forEach(function (pendingActionItem) {
                loadItemsProperties$.push(_this.constructPendingItemPropertiesFromSearch(pendingActionItems, pendingActionItem));
            });
        }
        return loadItemsProperties$.length ? zip_1.zip.apply(void 0, loadItemsProperties$).pipe(operators_1.map(function () { return pendingActionItems; })) : Observable_1.Observable.of([]);
    };
    PendingActionHelperService.prototype.setPendingActionItemInitialFinalState = function (pendingItem, structures) {
        var processStructure = structures
            .find(function (process) { return process.getCategorySystemName() === pendingItem.itemCategoryName; });
        pendingItem.initialStateId = processStructure && processStructure.getInitialStateId();
        pendingItem.finalStateIds = processStructure && processStructure.getStates()
            .filter(function (state) { return state.getIsFinal(); }).map(function (state) { return state.getId(); });
    };
    PendingActionHelperService.prototype.constructPendingItemPropertiesFromSearch = function (pendingActionItems, pendingActionItem) {
        var _this = this;
        var loadOverdueItems$ = this.overdueWarningService.getOverdueEntities(pendingActionItem.itemCategoryName);
        var loadOverduePortfolioItemsByFields$ = loadOverdueItems$.pipe(operators_1.switchMap(function (overdueItemIds) {
            if (overdueItemIds && overdueItemIds.length) {
                pendingActionItem.allOverdueItemIds = overdueItemIds;
                return _this.constructSearchableDataLoading(pendingActionItem, pending_item_type_1.PendingItemType.OVERDUE);
            }
            return Observable_1.Observable.of(0);
        }), operators_1.tap(function (overdueAmount) { return pendingActionItem.overdueItemsAmount = overdueAmount; }));
        var loadAllPortfolioItemsByFields$ = this.constructSearchableDataLoading(pendingActionItem, pending_item_type_1.PendingItemType.PENDING_ACTION).pipe(operators_1.tap(function (allAmount) {
            if (!allAmount) {
                pendingActionItems.splice(pendingActionItems.indexOf(pendingActionItem), 1);
            }
            pendingActionItem.pendingItemsAmount = allAmount;
        }));
        var loadDraftPortfolioItemsByFields$ = this.constructSearchableDataLoading(pendingActionItem, pending_item_type_1.PendingItemType.DRAFT).pipe(operators_1.tap(function (draftAmount) { return pendingActionItem.draftItemsAmount = draftAmount; }));
        var loadNonDraftPortfolioItemsByFields$ = this.constructSearchableDataLoading(pendingActionItem, pending_item_type_1.PendingItemType.PENDING_REACTION).pipe(operators_1.tap(function (nonDraftAmount) { return pendingActionItem.pendingReactionItemsAmount = nonDraftAmount; }));
        return zip_1.zip(loadOverduePortfolioItemsByFields$, loadAllPortfolioItemsByFields$, loadDraftPortfolioItemsByFields$, loadNonDraftPortfolioItemsByFields$);
    };
    PendingActionHelperService.prototype.constructSearchableDataLoading = function (pendingItem, pendingItemType) {
        return this.entitySearchService.loadPortfolioItemsByFields(pendingItem.itemCategoryName, new idm_de_core_frontend_1.PagingOptions(0, 0), null, PendingActionHelperService_1.constructPendingFilteringObjectByType(pendingItem, pendingItemType), static_method_1.uniteFilters(PendingActionHelperService_1.externalFilter, pendingItem.externalFilters), [idm_um_permission_client_js_1.CategoryPermissionType.VIEW], [pendingItem.instanceField]).pipe(operators_1.map(function (responseData) { return responseData && responseData.getTotalRowCount() || 0; }));
    };
    var PendingActionHelperService_1;
    PendingActionHelperService.externalFilter = { '$and': ['${hasWFAction}'] };
    PendingActionHelperService = PendingActionHelperService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_entity_search_client_js_1.EntitySearchService,
            idm_workflow_service_client_js_1.ProcessService,
            overdue_warning_service_1.OverdueWarningService,
            pending_action_settings_service_1.PendingActionSettingsService,
            idm_kb_service_client_js_1.KbService,
            portfolio_definitions_service_1.PortfolioDefinitionsService])
    ], PendingActionHelperService);
    return PendingActionHelperService;
}());
exports.PendingActionHelperService = PendingActionHelperService;
//# sourceMappingURL=pending-action-helper.service.js.map